<template>
  <section v-loading="loading">
    <div class="comDeclareResource">
      <div class="upBtn">
        <div>只允许上传pdf格式文件,表格全部上传后才可提交</div>
        <div>
          <!-- <a href="http://oss.henan.gov.cn/sbgt-wztipt/attachment/hnsjyt/UserFiles/File/20191029/1572336285889050333.pdf" download="111" target="_blank">ceshi</a> -->
          <el-button
            type="primary" @click="down(
              'http://oss.henan.gov.cn/sbgt-wztipt/attachment/hnsjyt/UserFiles/File/20191029/1572336285889050333.pdf',
              '申请表模板'
            )">
            下载申请表模板
          </el-button>
          <el-button
            type="primary"
            @click="down(
              'http://oss.henan.gov.cn/sbgt-wztipt/attachment/hnsjyt/UserFiles/File/20191029/1572336409134096951.pdf',
              '申请表模板'
            )">
            下载申报表模板
          </el-button>

          <el-button type="primary" :disabled="!canUp" @click="examine">
            {{ btnTitle }}
          </el-button>
        </div>
      </div>
      <div class="comDeclareResource-content">
        <div
          v-for="(item,index) in upItemList"
          :key="index"
          class="upItem"
          @click="clickItem=item.key"
        >
          <el-upload
            class="uploadBox"
            :action="action"
            accept=".pdf"
            :before-upload="befUp"
            :on-success="upSuccess"
          >
            <span>{{ item.label }}</span>
          </el-upload>
          <iframe
            v-if="item.src"
            :src="item.src"
            frameborder="0"
            type="application/x-google-chrome-pdf"
            width="100%"
            scrolling="auto"
            height="100%"
          />
        </div>
        <!--
        <div class="upItem">
          <el-upload
            class="uploadBox"
            action="http://36.137.252.61:8004/api/uploadFile"
          >
            <span>上传申报表</span>
          </el-upload>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import {
  newAddApplyApi,
  newAddDeclareApi,
  examineApi
} from '@/api/library.js'


// import { exportFile } from '@/utils'
export default {
  name: 'UpPDF',
  props: {
    pdfData: {
      type: Object
    }
  },
  data() {
    return {
      // libraryInfo: mock.library.declare.viewInfo,
      // libraryInit: mock.library.declare.init,
      upItemList: {
        Apply: {
          label: '上传申请表',
          key: 'Apply',
          src: '',
          request: newAddApplyApi,
          parameterKey: 'apply_url'
        },
        Declare: {
          label: '上传申报表',
          key: 'Declare',
          src: '',
          request: newAddDeclareApi,
          parameterKey: 'declare_url'
        }
      },
      clickItem: '',
      // apply_url: '',
      // declare_url: '',
      loading: false,
      status: 0 // 0未提交 1已提交 3审核通过',
    }
  },
  computed: {
    action() {
      return `${process.env.VUE_APP_BASE_API}api/uploadFile`
    },
    canUp() {
      let bol = null
      switch (this.status) {
        case 0:
          bol = this.upItemList.Apply.src && this.upItemList.Declare.src
          break
        case 1:
          bol = true
          break
        case 3:
          bol = false
          break
        default:
          break
      }
      return bol
    },
    btnTitle() {
      let str = ''
      switch (this.status) {
        case 0:
          str = '提交审核'
          break
        case 1:
          str = '返回编辑'
          break
        case 3:
          str = '已提交'
          break
        default:
          break
      }
      return str
    }
  },
  watch: {
    pdfData: {
      handler(val) {
        this.status = val.status
        this.upItemList.Apply.src = val.ApplySrc
        this.upItemList.Declare.src = val.DeclareSrc
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // this.getData()
  },
  methods: {
    // getData() {
    //   this.loading = true
    //   declareDataApi().then((res) => {
    //     this.upItemList.Apply.src = res.data.apply_url
    //     this.upItemList.Declare.src = res.data.declare_url
    //     this.status = res.data.status
    //     this.loading = false
    //   }).catch(() => {
    //     this.loading = false
    //   })
    // },
    upSuccess(res, file) {
      const obj = this.upItemList[this.clickItem]
      this.$set(obj, 'src', res.data[0])
      const parameter = {}
      parameter[obj.parameterKey] = res.data[0]
      obj.request(parameter).then((res) => {
        this.$message.success('上传成功')
      })
    },
    befUp(file) {
      if (file.type === 'application/pdf') {
        return true
      } else {
        this.$message.error('只允许上传pdf格式文件')
        return false
      }
    },
    examine(event) {
      let target = event.target
      if (target.nodeName == 'SPAN') {
        target = event.target.parentNode
      }
      target.blur()
      const status = this.status === 0 ? 1 : 0
      examineApi(
        { status }
      ).then((res) => {
        if (res.code === 100000) {
          // this.getData()
          this.$emit('callBack')
          const str = status === 0 ? '返回编辑成功' : '已提交'
          this.$message.success(str)
        }
      })
    },
    down(url, name) {
      window.open(url)
      // exportFile(url, name)
    }
  }
}
</script>
<style lang='scss' scoped>
.comDeclareResource {
  // overflow: hidden;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-tabs {
    margin-bottom: 22px;
    &-item {
      text-align: center;
      font-size: 10px;
      line-height: 32px;
      width: 112px;
      cursor: pointer;
      @include fun-design(4);
      border-radius: 6px;
      margin-right: 30px;
    }
    .activeTab {
      @include fun-active(1);
    }
  }
  &-content {
    flex: 1;
    width: 100%;
    // @include fun-layout(2);
    margin-bottom: 10px;
    // min-height: 680px;
    display: flex;
    // align-items: center;
    justify-content: space-between;

    > section {
      height: 100%;
    }
  }
}
.upBtn{
  width: 100%;
  display: flex;
  justify-content:space-between;
  align-items: center;
  margin-bottom: 20px;
}
.upItem{
  width: 48%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .uploadBox{
    width: 100px;
    height: 100px;
    border: 1px dashed #ccc;
    background: #EFEFEF;
    margin-bottom: 10px;
  }
}
</style>
